export var ScrapbookElementType;
(function (ScrapbookElementType) {
    ScrapbookElementType["TEXT"] = "text";
    ScrapbookElementType["SHAPE"] = "shape";
    ScrapbookElementType["CIRCLE"] = "circle";
    ScrapbookElementType["IMAGE"] = "image";
    ScrapbookElementType["DRAWING"] = "drawing";
    ScrapbookElementType["LINE"] = "line";
    ScrapbookElementType["ARROW"] = "arrow";
    ScrapbookElementType["POLYGON"] = "polygon";
    ScrapbookElementType["PEN"] = "pen";
    ScrapbookElementType["RFI"] = "rfi";
    ScrapbookElementType["FILTER"] = "filter";
    ScrapbookElementType["SUBMITTAL"] = "submittal";
    ScrapbookElementType["CLOUD"] = "cloud";
})(ScrapbookElementType || (ScrapbookElementType = {}));
export var ScrapbookDocType;
(function (ScrapbookDocType) {
    ScrapbookDocType["page"] = "page";
    ScrapbookDocType["element"] = "element";
    ScrapbookDocType["section"] = "section";
})(ScrapbookDocType || (ScrapbookDocType = {}));
export var ScrapbookReferenceType;
(function (ScrapbookReferenceType) {
    ScrapbookReferenceType["RFI"] = "rfi";
    ScrapbookReferenceType["SECTION"] = "section";
    ScrapbookReferenceType["TASK"] = "task";
    ScrapbookReferenceType["SUBMITTAL"] = "submittal";
})(ScrapbookReferenceType || (ScrapbookReferenceType = {}));
